import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "font-refresh registration-main"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "font-weight-bold" }, "Sign up for a 14-day free trial", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "push-20-t text-body" }, "After sign-up, you'll be able to:", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Get instant access to the AdvicePay platform while we verify your account"),
  /*#__PURE__*/_createElementVNode("li", null, "Create one-time or recurring invoices for your clients"),
  /*#__PURE__*/_createElementVNode("li", null, "Accept card and ACH payments")
], -1 /* HOISTED */)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xs-4 push-5-t pad-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/img/money.svg",
  class: "img-fluid pull-10-t"
}, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "push-15-t dis-block fw-600" }, "Essential", -1 /* HOISTED */)
const _hoisted_9 = { class: "col-xs-4 push-5-t pad-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/img/people.svg",
  class: "pull-10-t"
}, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "push-15-t dis-block fw-600" }, "Professional", -1 /* HOISTED */)
const _hoisted_12 = { class: "col-xs-4 push-5-t pad-5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/img/bank_building.svg",
  class: "pull-10-t"
}, null, -1 /* HOISTED */)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "push-15-t dis-block fw-600" }, "Enterprise", -1 /* HOISTED */)
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "row push-10-t" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-left col-xs-7 push-10-t align-middle" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "push-5-t" }, [
    /*#__PURE__*/_createTextVNode("Already have an account? "),
    /*#__PURE__*/_createElementVNode("a", { href: "/" }, "Sign in")
  ])
], -1 /* HOISTED */)
const _hoisted_18 = { class: "text-right col-xs-5 push-10-t" }
const _hoisted_19 = {
  key: 0,
  class: "btn push-10-l rounded-5 registration-submit-btn",
  href: "mailto:sales@advicepay.com",
  target: "_blank"
}
const _hoisted_20 = {
  key: 1,
  class: "btn push-10-l registration-submit-btn",
  type: "submit"
}
const _hoisted_21 = {
  key: 1,
  class: "text-center font-refresh"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/success.svg" }, null, -1 /* HOISTED */)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h1", { class: "h1 push-20-t" }, "User added!", -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "push-15-t" }, "A new Advisor account has been added to your existing login.", -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_27 = ["href"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h1", { class: "h1 push-20-t" }, "Check your email!", -1 /* HOISTED */)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "push-15-t" }, "A link to activate your account has been emailed to the address provided.", -1 /* HOISTED */)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "push-15-t" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioTile = _resolveComponent("RadioTile")!
  const _component_FormField = _resolveComponent("FormField")!
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createBlock(_component_Container, {
    plan: _ctx.form.plan
  }, {
    content: _withCtx(() => [
      (!_ctx.submitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
              class: "push-20-t"
            }, [
              _createVNode(_component_FormField, {
                class: "font-weight-bold",
                label: "Select your plan:",
                val: _ctx.form.plan,
                v: _ctx.formValidations.plan
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_RadioTile, {
                        modelValue: _ctx.form.plan,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.plan) = $event)),
                        inputVal: _ctx.accountTypes.ESSENTIAL,
                        class: "plan-tile text-center",
                        primaryColor: _ctx.primaryColor(_ctx.accountTypes.ESSENTIAL),
                        secondaryColor: _ctx.secondaryColor(_ctx.accountTypes.ESSENTIAL)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7,
                          _hoisted_8
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["modelValue", "inputVal", "primaryColor", "secondaryColor"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_RadioTile, {
                        modelValue: _ctx.form.plan,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.plan) = $event)),
                        inputVal: _ctx.accountTypes.PROFESSIONAL,
                        class: "plan-tile text-center",
                        primaryColor: _ctx.primaryColor(_ctx.accountTypes.PROFESSIONAL),
                        secondaryColor: _ctx.secondaryColor(_ctx.accountTypes.PROFESSIONAL)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          _hoisted_11
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["modelValue", "inputVal", "primaryColor", "secondaryColor"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_RadioTile, {
                        modelValue: _ctx.form.plan,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.plan) = $event)),
                        inputVal: _ctx.accountTypes.ENTERPRISE,
                        class: "plan-tile text-center",
                        primaryColor: _ctx.primaryColor(_ctx.accountTypes.ENTERPRISE),
                        secondaryColor: _ctx.secondaryColor(_ctx.accountTypes.ENTERPRISE)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13,
                          _hoisted_14
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["modelValue", "inputVal", "primaryColor", "secondaryColor"])
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["val", "v"]),
              _createVNode(_component_FormField, {
                label: "Email Address:",
                val: _ctx.form.email,
                v: _ctx.formValidations.email,
                class: "push-20-t"
              }, {
                default: _withCtx((slotProps) => [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control rounded",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.email) = $event)),
                    id: slotProps.id
                  }, null, 8 /* PROPS */, _hoisted_15), [
                    [
                      _vModelText,
                      _ctx.form.email,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["val", "v"]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  (_ctx.form.plan == _ctx.accountTypes.ENTERPRISE)
                    ? (_openBlock(), _createElementBlock("a", _hoisted_19, "Talk to Sales"))
                    : (_openBlock(), _createElementBlock("button", _hoisted_20, "Get Started"))
                ])
              ])
            ], 32 /* NEED_HYDRATION */)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.submitted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            (_ctx.alreadyVerified)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _hoisted_24,
                  _hoisted_25,
                  _hoisted_26,
                  _createElementVNode("a", {
                    class: "btn btn-primary",
                    href: _ctx.baseURL
                  }, "Close", 8 /* PROPS */, _hoisted_27)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _hoisted_29,
                  _hoisted_30,
                  _hoisted_31,
                  _createElementVNode("a", {
                    class: "btn btn-primary",
                    href: _ctx.baseURL
                  }, "Close", 8 /* PROPS */, _hoisted_32),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resend && _ctx.resend(...args)), ["prevent"]))
                    }, "Re-send verification link")
                  ])
                ]))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["plan"]))
}